export default __webpack_public_path__ + "static/media/organization-order-sample.b200c304.png";